import { observer } from "mobx-react";
import React from "react";
import { useIntl } from "react-intl";

import { useAutoFocus } from "../../hooks/useAutoFocus";
import useStores from "../../hooks/useStores";
import ButtonWithRef from "../elements/Button";
import WindowPopup from "./WindowPopup";

const CheckPlanPopup = observer(() => {
  const { formatMessage } = useIntl();
  const { uiState } = useStores();
  const { confirmCallback } = uiState;

  const ref = React.useRef();
  useAutoFocus(ref);

  return (
    <WindowPopup
      className="window-dialog"
      title={formatMessage({
        id: "dialog.checkPlan.confirm.title",
      })}
    >
      <form>
        <div className="dialog-text">
          <div className="dialog-message">
            {formatMessage({
              id: "dialog.checkPlan.confirm.question",
            })}
          </div>
        </div>

        <div className="dialog-buttons">
          <ButtonWithRef
            className="cancel"
            title={formatMessage({
              id: "dialog.cancel",
            })}
            onClick={() => confirmCallback(false)}
          />

          <ButtonWithRef
            className="ok"
            title={formatMessage({
              id: "dialog.ok",
            })}
            onClick={() => confirmCallback(true)}
            ref={ref}
          />
        </div>
      </form>
    </WindowPopup>
  );
});

export default CheckPlanPopup;
